import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const CogIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 22"
      height={getDefaultHeight(svgProps, 22)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9.7 2.5a1.7 1.7 0 0 0 2.6 0l.8-1a1.7 1.7 0 0 1 3 1.3v1.3a1.7 1.7 0 0 0 1.8 1.8h1.3a1.7 1.7 0 0 1 1.2 3l-.9.8a1.7 1.7 0 0 0 0 2.6l1 .8a1.7 1.7 0 0 1-1.3 3h-1.3a1.7 1.7 0 0 0-1.8 1.8v1.3a1.7 1.7 0 0 1-3 1.2l-.8-.9a1.7 1.7 0 0 0-2.6 0l-.8 1a1.7 1.7 0 0 1-3-1.3v-1.3a1.7 1.7 0 0 0-1.8-1.8H2.8a1.7 1.7 0 0 1-1.2-3l.9-.8a1.7 1.7 0 0 0 0-2.6l-1-.8a1.7 1.7 0 0 1 1.3-3h1.3a1.7 1.7 0 0 0 1.8-1.8V2.8a1.7 1.7 0 0 1 3-1.2l.8.9Z" />
      <path d="M11 13.6a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2Z" />
    </SVG>
  );
};
